import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class NoteTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('NoteTypeReference');
  }
}
